import styled from "@emotion/styled";

import { FONT_WEIGHT_BOLD, FONT_WEIGHT_NORMAL } from "@skilitics/designer-ui-components";
import { useFormatMessage, type FormatMessages } from "@skilitics/localization";

const ViewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  padding: var(--page-padding);
`;

const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;

  width: 280px;
  height: 295px;
  max-height: 295px;

  opacity: 0.5;

  background-color: ${({ theme }) => theme.generalTextIconFill};

  border-radius: 16px;

  box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.1);

  overflow: hidden;
`;

const Thumbnail = styled.div`
  position: relative;

  display: flex;
  width: 100%;
  height: 200px;

  overflow: hidden;

  border-start-start-radius: 16px;
  border-start-end-radius: 16px;

  > img {
    width: 100%;
    height: 200px;
  }
`;

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 5px;

  width: 100%;
  height: 94px;

  font-size: 14px;
  color: ${({ theme }) => theme.generalTextIcon};

  padding: 14px 15px;
  overflow: hidden;
`;

const Title = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;

  font-weight: ${FONT_WEIGHT_BOLD};

  overflow: hidden;
`;

const Description = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;

  font-size: 12px;
  font-weight: ${FONT_WEIGHT_NORMAL};

  overflow: hidden;
`;

export const EmptyView = () => {
  const formatMessage = useFormatMessage(formatStrings);

  return (
    <ViewContainer data-test="empty-view-container">
      {/* TODO: awaiting final design for location of <AddButton /> */}
      <Container>
        <Thumbnail>
          <img src="/assets/empty_warehouse.jpg" alt={formatMessage("noModules")} />
        </Thumbnail>
        <DetailsContainer>
          <Title>{formatMessage("title")}</Title>
          <Description>{formatMessage("description")}</Description>
        </DetailsContainer>
      </Container>
    </ViewContainer>
  );
};

const formatStrings = {
  title: {
    en: "No Projects Available",
  },
  description: {
    en: "Projects are used to integrate related content and activities based on a learning objective.",
  },
  noModules: {
    en: "No Projects",
  },
} satisfies FormatMessages;
